import { Tooltip } from "@octopusdeploy/design-system-components";
import { toGitRefShort, type GitBranchResource, type GitRef, type ProjectResource } from "@octopusdeploy/octopus-server-client";
import { ProjectGitRefSelector } from "~/areas/projects/components/GitRefSelector/ProjectGitRefSelector";
import { repository } from "~/clientInstance";
import { useNotifyCreateBranch } from "./Analytics/useNotifyCreateBranch";
export interface BranchSelectorProps {
    project: ProjectResource;
    gitRef: GitRef | undefined;
    setGitRef: (gitRef: string) => void;
    errorMessage?: string;
}
export function BranchSelector({ project, gitRef, setGitRef, errorMessage }: BranchSelectorProps) {
    const createBranchDispatcher = useNotifyCreateBranch();
    // When the gitRef is set in queryParams, such as RunbooksPage, the gitRef value could be undefined, so the following check is necessary.
    // The gitRef is validated when the page component is mounted, then the gitRef queryParams is updated if necessary, such as setting to default branch if the value is undefined.
    if (!gitRef && !errorMessage) {
        return null;
    }
    const onCreateBranch = async (newBranchName: string, parentGitRef: GitRef): Promise<GitBranchResource> => {
        const newBranchResource = await createBranchDispatcher({
            source: "Branch switcher",
            createBranchAction: () => repository.ProjectBranches.createBranch(project.Id, newBranchName, parentGitRef),
        });
        setGitRef(newBranchResource.CanonicalName);
        return newBranchResource;
    };
    const selector = <ProjectGitRefSelector onChange={setGitRef} project={project} initialGitRef={gitRef} onCreateBranch={onCreateBranch} errorMessage={errorMessage}/>;
    const shortName = toGitRefShort(gitRef);
    return shortName ? <Tooltip content={shortName}>{selector}</Tooltip> : selector;
}
